import { FONTS, getFontStyle, getTitleStyle, getContentStyle, getControlStyle, getMenuStyle } from '../config/fonts';

/**
 * Hook personalizado para manejar fuentes de manera consistente
 * Permite cambiar la fuente de todo el sitio desde un solo lugar
 */
export const useFonts = () => {
  return {
    // Fuentes disponibles
    fonts: FONTS,
    
    // Funciones helper para aplicar fuentes
    getFontStyle,
    getTitleStyle,
    getContentStyle,
    getControlStyle,
    getMenuStyle,
    
    // Estilos predefinidos comunes
    title: getTitleStyle({
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#00468B'
    }),
    
    sectionTitle: getTitleStyle({
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#00468B'
    }),
    
    content: getContentStyle({
      fontSize: '14px',
      color: '#374151'
    }),
    
    button: getControlStyle({
      fontSize: '14px',
      fontWeight: '500'
    }),
    
    menuItem: getMenuStyle({
      fontSize: '14px',
      color: '#374151'
    }),
    
    tableHeader: getTitleStyle({
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151'
    }),
    
    tableCell: getContentStyle({
      fontSize: '14px',
      color: '#374151'
    })
  };
};

export default useFonts;
